import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/stones.php';

export function getStones() {

    const response = api.get(service_path);

    return response;
};

export function getStoneDetails(id, setData) {

    const response = api.get(`${service_path}?id=${id}`)

    return response;
};

export function createStone(data, navigateBack) {
    api.post(service_path, data)
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Pedra cadastrada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message || "Houve um erro ao cadastrar a pedra!");
            }
        })
        .catch(error => {
            globalToast.error("Houve um erro ao executar essa ação!");
            console.log(error);
        });
}

export function updateStone(data, navigateBack) {
    api.patch(service_path, data)
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Pedra editada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message || "Houve um erro ao editar a pedra!");
            }
        })
        .catch(error => {
            globalToast.error("Houve um erro ao executar essa ação!");
            console.log(error);
        });
}

export function deleteStone(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;
            if (data.success) {
                globalToast.success("Pedra deletada com sucesso!");
            } else {
                globalToast.error(data.message || "Houve um erro ao deletar a pedra!");
            }
        })
        .catch(error => {
            globalToast.error("Houve um erro ao executar essa ação!");
            console.log(error);
        });
}